export default "__VITE_ASSET__D6kRP5AR__"